document.addEventListener("DOMContentLoaded", () => {
	const WISHLIST_KEY = "wishlist"; // localStorageに保存するキー名

	function getWishlist() {
		return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
	}

	function setWishlist(list) {
		localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
	}

	// 特定の productId のボタンをまとめて更新
	function updateButtonState(productId, list) {
		const buttons = document.querySelectorAll(
			`.wishlist-button[data-product-id="${productId}"]`
		);
		buttons.forEach((button) => {
			if (list.includes(productId)) {
				button.classList.add("active");
			} else {
				button.classList.remove("active");
			}
		});
	}

	// 初期化
	const wishlist = getWishlist();
	document.querySelectorAll(".wishlist-button").forEach((button) => {
		const productId = button.dataset.productId;
		updateButtonState(productId, wishlist);

		// ボタンクリック処理
		button.addEventListener("click", () => {
			let list = getWishlist();
			if (list.includes(productId)) {
				list = list.filter((id) => id !== productId); // 削除
			} else {
				list.push(productId); // 追加
			}
			setWishlist(list);
			updateButtonState(productId, list); // 同じ商品IDのボタンすべて更新
		});
	});
});
